import {postCreateGroup} from '../api/postCreateGroup';
import {setGroups} from './setGroups';

const setCreateGroup = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateGroup(params);
            dispatch(setGroups({
                group: ''
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setCreateGroup
}